const colors = {
  white: '#FFFFFF',
  primaryPurple: '#786FFF',
  primaryLight: '#E4E2FF',
  positive: '#1AB77F',
  lightPositive: '#D1F1E5',
  timer: '#00D4B4',
  warning: '#FBB028',
  lightWarning: '#FEEFD4',
  negative: '#FF6473',
  lightNegative: '#FFE1E4',
  lightestNegative: '#FFEFF1',
  ultrablack: '#2D2D2D',
  backDropColor: '#273443', // same as black
  black: '#273443',
  /**
   * input dropdown option and selected value (note that selected will be bold)
   * input label
   * */
  darkGray: '#3F4E61', // main + study time
  main2: '#8492A5',
  /**
   * - input placeholder
   * - icons
   * - input border
   * */
  captures: '#D3DCE6',
  /**
   * hover/focus input background
   * hover dropdown select */
  backgroundDark: '#F5F7FA', // bg dark
  backgroundLight: '#F9FAFC',
  bottomBorderColor: '#e0e6ed',
  disable: '#F2F3F5',
  customEventColor: '#56CCF2',

  /*TODO: rename */
  warningAxisColor: '#FADE7D'
};

export default colors;
